var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreePoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17315,
    cy: 2.43877,
    r: 2.17315,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.1773,
    cy: 8.9583,
    r: 2.17315,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.1773,
    cy: 16.5638,
    r: 2.17315,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreePoints);
export default __webpack_public_path__ + "static/media/treePoints.4d391f9c8014e58f6f34a79732c8c2d4.svg";
export { ForwardRef as ReactComponent };